// 追従バナーの表示制御

document.addEventListener("DOMContentLoaded", function () {
  const banner = document.querySelector(".cta-fixed-banner");
  if (!banner) return;

  function toggleBanner() {
    if (window.scrollY > 100) {
      banner.classList.add("cta-fixed-banner--active");
    } else {
      banner.classList.remove("cta-fixed-banner--active");
    }
  }

  window.addEventListener("scroll", toggleBanner);
  // 初期表示時にも判定
  toggleBanner();
});
